// @flow
import React, { type Node } from 'react';
import classnames from 'classnames';

import { COLORS } from 'Components/utils/color/colors.js';

import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

type Props = {
  children: Node,
  className?: string,
  color: Colors,
  controlsId?: string,
  id?: string,
  isActive?: boolean,
  onClick?: () => void,
  trackingData?: ?TrackingData,
};

export function NavigationTabsHeader(props: Props) {
  const {
    children,
    className,
    color = COLORS.BLUE,
    controlsId,
    id,
    isActive,
    onClick,
    trackingData,
  } = props;

  return (
    <TrackClick
      aria-controls={controlsId}
      aria-selected={isActive}
      as="button"
      className={classnames(
        className,
        'cursor-pointer h-navigation-tabs px-3 py-2 text-base transition-colors',
        `focus:bg-${color} focus:text-white hover:bg-${color} hover:text-white`,
        {
          [`bg-${color} text-white`]: isActive,
          'bg-white text-gray-darker': !isActive,
        },
      )}
      id={id}
      onClick={onClick}
      role="tab"
      style={{ minWidth: '7.5rem' }}
      tabIndex={isActive ? 0 : -1}
      {...(trackingData ? { trackingData } : null)}
    >
      {children}
    </TrackClick>
  );
}
